export default () => ({
  type: "eu",

  setType(type) {
    this.type = type;
  },
});
